class OversellNotice extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    const formId = this.getAttribute('form');

    const onQuantityChange = (event) => {
      // Compare the attribute: the product form has an input named "id", so form.id is that input, not the form's ID
      if (event.target.name === 'quantity' && event.target.getAttribute('form') === formId) this.update();
    };
    document.addEventListener('input', onQuantityChange, options);
    document.addEventListener('change', onQuantityChange, options);

    document.addEventListener('cart:change', (event) => {
      const items = event.detail?.cart?.items;
      if (!items) return;

      this.dataset.cartQuantity = items.reduce((total, item) =>
        total + (String(item.variant_id) === this.dataset.variantId ? item.quantity : 0), 0);
      this.update();
    }, options);

    this.update();
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  update() {
    const input = document.querySelector(`input[name="quantity"][form="${CSS.escape(this.getAttribute('form'))}"]`);
    const selected = Number(input?.value) || 1;

    this.hidden = selected + Number(this.dataset.cartQuantity) <= Number(this.dataset.stock);

    // The in-stock text promises same-day shipping, which no longer holds for the whole order
    const status = this.parentElement.querySelector(':scope > span');
    if (status) status.hidden = !this.hidden;
  }
}

if (!customElements.get('oversell-notice')) {
  customElements.define('oversell-notice', OversellNotice);
}
